"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsSection = void 0;
const react_1 = __importStar(require("react"));
const DocumentsSection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    const documentsData = data.documents || [];
    const handleFileChange = (0, react_1.useCallback)((documentId, fileName, e) => {
        const file = e.target.files?.[0];
        if (!file)
            return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const updated = [...documentsData];
            const existing = updated.findIndex((d) => d.documentId === documentId);
            const entry = { documentId, file: reader.result, fileName: file.name };
            if (existing >= 0) {
                updated[existing] = entry;
            }
            else {
                updated.push(entry);
            }
            onChange('documents', updated);
        };
        reader.readAsDataURL(file);
    }, [documentsData, onChange]);
    const docLookup = lookups?.documents || [];
    const getDocName = (id) => {
        const doc = docLookup.find((d) => Number(d.value) === id);
        return doc?.label || doc?.displayName || `Document #${id}`;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, section.categories.map((category) => (react_1.default.createElement("div", { key: category.id, className: "document-category" },
        react_1.default.createElement("div", { className: "document-category-title" }, category.label),
        category.documentIds.map((docId) => {
            const uploaded = documentsData.find((d) => d.documentId === docId);
            return (react_1.default.createElement("div", { key: docId, className: "document-item" },
                react_1.default.createElement("div", { className: "document-item-name" }, getDocName(docId)),
                react_1.default.createElement("input", { type: "file", onChange: (e) => handleFileChange(docId, getDocName(docId), e), disabled: disabled }),
                uploaded && (react_1.default.createElement("span", { className: "field-hint", style: { color: '#06D6A0' } }, uploaded.fileName)),
                errors[`documents.${docId}`] && (react_1.default.createElement("div", { className: "field-error" }, errors[`documents.${docId}`]))));
        }))))));
};
exports.DocumentsSection = DocumentsSection;
